import { useCallback, useEffect, useState, Fragment } from "react";
import { useParams } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import {
  StyledCardContent,
  StyledCardContentDetail,
  StyledTypography,
  StyledStatus,
  StyledIcondiv,
  StyledCardContentDetailProduct,
  StyledTypographyProduct,
} from "./Order.style";
import ContactCM from "components/contactus";
import { getOrderInfoRequest } from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import BackButton from "components/shared/BackButton";
import spliter from "helper/digit-spliter";
import { IMG_BASE_URL } from "constants";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {Helmet} from "react-helmet";

export default function Order() {
  const params = useParams();
  const { request, loading } = useHttp();
  const [order, setOrder] = useState([]);
  const [products, setProducts] = useState([]);

  const getOrder = useCallback(async () => {
    let res = await request({
      url: getOrderInfoRequest,
      values: params.orderId,
    });
    if (res) {
      const transformedProducts = res.order_contents.map((items, index) => ({
        id: index,
        quantity: items.quantity,
        total_price: items.total_price,
        product_color: items.product_color?.color_code,
        product_color_name: items.product_color?.title,
        product_name: items.product_color?.product?.title,
        product_image: items.product_color?.product?.image,
      }));

      setProducts(transformedProducts);
      setOrder(res);
    }
  }, [request, params.orderId]);

  useEffect(() => {
    getOrder();
  }, [getOrder]);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>فاکتور - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="فاکتور" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  فاکتور
                </Typography>
              </StyledCardContent>
              {loading ? (
                <div style={{ textAlign: "center", padding: "28px" }}>
                  در حال دریافت اطلاعات
                </div>
              ) : (
                <>
                  <StyledCardContentDetail>
                    {order?.payment_status == "failed" ? (
                      <StyledStatus>
                        <StyledIcondiv>
                          <HighlightOffIcon style={{ color: "red" }} />
                        </StyledIcondiv>
                        <span>سفارش ناموفق</span>
                      </StyledStatus>
                    ) : (
                      <StyledStatus>
                        <StyledIcondiv>
                          <CheckCircleOutlineIcon style={{ color: "green" }} />
                        </StyledIcondiv>
                        <span>سفارش موفق</span>
                      </StyledStatus>
                    )}
                  </StyledCardContentDetail>
                  <StyledCardContentDetail>
                    <StyledTypography variant="body2">
                      <span>شماره سفارش : </span>
                      {order?.order_number}
                    </StyledTypography>
                    <StyledTypography variant="body2">
                      <span>تاریخ : </span>
                      {order?.created_at?.jdate}
                    </StyledTypography>
                  </StyledCardContentDetail>
                  <StyledCardContentDetail style={{ flexDirection: "column" }}>
                    <div>
                      <StyledTypography variant="body2">
                        <span>استان : </span>
                        {order?.user_address?.state}
                      </StyledTypography>
                      <StyledTypography variant="body2">
                        <span>شهر : </span>
                        {order?.user_address?.city}
                      </StyledTypography>
                      <StyledTypography variant="body2">
                        <span>کدپستی : </span>
                        {order?.user_address?.postal_code}
                      </StyledTypography>
                    </div>
                    <StyledTypography variant="body2">
                      <span>آدرس : </span>
                      {order?.user_address?.address}
                    </StyledTypography>
                  </StyledCardContentDetail>
                  <StyledCardContentDetail>
                    <StyledTypography variant="body2">
                      <span>تخفیف : </span>
                      {order?.discount_code == null
                        ? "ندارد"
                        : spliter(order?.discount_code?.amount) + " تومان "}
                    </StyledTypography>
                    <StyledTypography variant="body2">
                      <span>مبلغ نهایی : </span>
                      {order?.total_price && spliter(order?.total_price)} تومان
                    </StyledTypography>
                  </StyledCardContentDetail>
                  <div>
                    {products.map((item, index) => (
                      <StyledCardContentDetailProduct key={index}>
                        <img
                          src={IMG_BASE_URL + item?.product_image}
                          alt={item?.product_color?.product?.title}
                          title={item?.product_color?.product?.title}
                        />
                        <div>
                          <StyledTypographyProduct variant="body2">
                            {item?.product_name}
                          </StyledTypographyProduct>
                          <StyledTypographyProduct variant="body2">
                            <span> رنگ : </span>
                            <div>
                              <div
                                style={{
                                  background: item?.product_color,
                                }}
                              ></div>
                              {item?.product_color_name}
                            </div>
                          </StyledTypographyProduct>
                          <StyledTypographyProduct variant="body2">
                            <span> تعداد : </span>
                            {item?.quantity} عدد
                          </StyledTypographyProduct>
                          <StyledTypographyProduct variant="body2">
                            <span> مبلغ : </span>
                            {spliter(item?.total_price)} تومان
                          </StyledTypographyProduct>
                        </div>
                      </StyledCardContentDetailProduct>
                    ))}
                  </div>

                  <Grid
                    container
                    style={{ paddingLeft: "30px", direction: "ltr" }}
                  >
                    <Grid item mt={3} mb={3} xs={12}>
                      <BackButton />
                    </Grid>
                  </Grid>
                </>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
